import { Deserializable } from '../protocols/deserializable';
import { OptionScale } from '../enum/dto/option-scale.enum';
import { DisplayOptionTimeDuration } from './display-option-time-duration';

export const DEFAULT_ROTATION_INTERVAL = 30;

export class DisplayOptions implements Deserializable {
  public scale: OptionScale = OptionScale.CenterCrop;
  public rotationInterval: Map<string, number> = new Map();
  public rotationOrder: Map<string, number> = new Map();
  public defaultValue: string;
  public overrides: Map<string, DisplayOptionTimeDuration> = new Map();

  public onDeserialize() {
    // If initializing new instance from properly mapped object, we can ignore the map deserialization
    if (!(this.rotationInterval instanceof Map)) {
      this.rotationInterval = window.injector.Deserialize.genericMap<string, number>(this.rotationInterval);
    }
    if (!(this.rotationOrder instanceof Map)) {
      this.rotationOrder = window.injector.Deserialize.genericMap<string, number>(this.rotationOrder);
    }
    if (!(this.overrides instanceof Map)) {
      this.overrides = window.injector.Deserialize.mapOf(DisplayOptionTimeDuration, this.overrides);
    }
  }

  public removeId(id: string) {
    this.rotationInterval?.delete(id);
    this.overrides?.delete(id);
    this.rotationOrder?.delete(id);
  }

  static defaultOptions(defaultMenuId: string): DisplayOptions {
    const opts = new DisplayOptions();
    opts.defaultValue = defaultMenuId;
    opts.rotationOrder = new Map<string, number>();
    opts.rotationOrder.set(defaultMenuId, 0);
    opts.rotationInterval = new Map<string, number>();
    opts.rotationInterval.set(defaultMenuId, DEFAULT_ROTATION_INTERVAL);
    return opts;
  }
}
